export const metaAdapter = (data) => {
  const { filter, _sort } = data;

  return {
    limit: data.limit,
    offset: data.offset,
    totalCount: data.total_count,
    filter: {
      countryId: filter.country_id,
      countrySlug: filter.country_slug,
      pageType: filter.page_type,
      countryName: filter.country_name,
    },
    sort: {
      field: _sort.field,
      type: _sort.type,
    },
  };
};
